var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 13.3333C19.6875 13.3333 20 13.6667 20 14V15.3333C20 15.7083 19.6875 16 19.375 16H1.25C0.546875 16 0 15.4167 0 14.6667V0.666667C0 0.333333 0.273438 0 0.625 0H1.875C2.1875 0 2.5 0.333333 2.5 0.666667V13.3333H19.375ZM18.125 1.33333C18.4375 1.33333 18.75 1.66667 18.7109 2V6.95833C18.7109 7.83333 17.7344 8.29167 17.1484 7.66667L15.8594 6.29167L12.1094 10.2917C11.6406 10.8333 10.8203 10.8333 10.3516 10.2917L7.5 7.25L5.66406 9.16667C5.42969 9.41667 5.03906 9.41667 4.80469 9.16667L3.90625 8.20833C3.67188 7.95833 3.67188 7.54167 3.90625 7.29167L6.60156 4.41667C7.07031 3.875 7.89063 3.875 8.35938 4.41667L11.25 7.45833L14.1016 4.41667L12.8125 3.04167C12.2266 2.41667 12.6562 1.33333 13.4766 1.33333H18.125Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashMenuIcon);
export default __webpack_public_path__ + "static/media/dash-menu-icon.e2e645fe4738c67a3165ab60a49411b4.svg";
export { ForwardRef as ReactComponent };